var React = require('react');

function DoubleEllipse (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"177.309","cy":"176.612","r":"145.5","transform":"rotate(-13.7072 177.309 176.612)","stroke":"#EAEAEA","key":0}),React.createElement("circle",{"cx":"226.691","cy":"193.388","r":"145.5","transform":"rotate(-13.7072 226.691 193.388)","stroke":"#EAEAEA","key":1})]);
}

DoubleEllipse.defaultProps = {"width":"404","height":"370","viewBox":"0 0 404 370","fill":"none"};

module.exports = DoubleEllipse;

DoubleEllipse.default = DoubleEllipse;
